export default __webpack_public_path__ + "static/media/flexline_black_logo_no.d286dd13.png";